import { RefObject, useEffect } from 'react';

export const useDecorativeVideo = (
  videoRef: RefObject<HTMLVideoElement | null>,
  playbackRate = 1.5,
) => {
  useEffect(() => {
    const video = videoRef.current;

    if (!video) {
      return;
    }

    const syncPlayback = () => {
      video.playbackRate = playbackRate;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => undefined);
      }
    };

    syncPlayback();
    video.addEventListener('loadedmetadata', syncPlayback);

    return () => {
      video.removeEventListener('loadedmetadata', syncPlayback);
    };
  }, [playbackRate, videoRef]);
};
